module.exports = __webpack_public_path__ + "media/images/flags/1x1/jpn-835ece4e6431737da7f790d40461f3ff.svg";